import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import PlayerCardComponent from '../components/PlayerCardComponent';
import { AuthContext } from '../auth/AuthContext';
import '../global.css';
import { fetchWithAuth } from '../utils/fetchWithAuth';

const CoachPlayersPage = () => {
  const { token } = useContext(AuthContext);
  const [players, setPlayers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPlayers = async () => {
      const res = await fetch('https://vballbackend.onrender.com/api/coach/players', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      setPlayers(data.players || []);
    };

    fetchPlayers();
  }, [token]);

  const handleCreatePlayer = () => {
    navigate('/create-player');
  };

  const filteredPlayers = players.filter(player =>
    player.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="container" style={{ paddingTop: '2rem' }}>
      <h1 className="mb-4">All Players</h1>

      {/* Search & Create Button */}
      <div className="flex-row mb-4" style={{ gap: '1rem', alignItems: 'center' }}>
        <input
          type="text"
          placeholder="Search by name..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className="flex-grow"
          style={{
            padding: '0.5rem',
            border: '1px solid #D1D5DB',
            borderRadius: '0.375rem',
            fontSize: '1rem'
          }}
        />
        <button className="btn-primary" onClick={handleCreatePlayer}>
          + Create New Player
        </button>
      </div>

      {/* Player Grid or Empty State */}
      {filteredPlayers.length === 0 ? (
        <p className="text-muted" style={{ fontStyle: 'italic' }}>
          No players match your search.
        </p>
      ) : (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
            gap: '1.5rem'
          }}
        >
          {filteredPlayers.map((player) => (
            <PlayerCardComponent key={player.id} player={player} />
          ))}
        </div>
      )}
    </div>
  );
};

export default CoachPlayersPage;
